import type { TFunction } from "i18next";

/**
 * Converts an i18next language code (e.g. `fr_FR`) into a BCP 47 locale
 * (e.g. `fr-FR`) usable by `Intl` APIs.
 */
export const toLocale = (language: string) => {
  return language.replace("_", "-");
};

export const getDateSelectorLocales = (t: TFunction) => {
  return {
    selectDate: t("date_selector.select_date"),
    apply: t("date_selector.apply"),
    cancel: t("date_selector.cancel"),
    clear: t("date_selector.clear"),
    today: t("date_selector.today"),
    filterTypes: {
      is: t("date_selector.filter_types.is"),
      before: t("date_selector.filter_types.before"),
      after: t("date_selector.filter_types.after"),
      between: t("date_selector.filter_types.between"),
    },
    periodTypes: {
      day: t("date_selector.period_types.day"),
      month: t("date_selector.period_types.month"),
      quarter: t("date_selector.period_types.quarter"),
      halfYear: t("date_selector.period_types.half_year"),
      year: t("date_selector.period_types.year"),
    },
    months: [
      t("date_selector.months.january"),
      t("date_selector.months.february"),
      t("date_selector.months.march"),
      t("date_selector.months.april"),
      t("date_selector.months.may"),
      t("date_selector.months.june"),
      t("date_selector.months.july"),
      t("date_selector.months.august"),
      t("date_selector.months.september"),
      t("date_selector.months.october"),
      t("date_selector.months.november"),
      t("date_selector.months.december"),
    ],
    monthsShort: [
      t("date_selector.months_short.jan"),
      t("date_selector.months_short.feb"),
      t("date_selector.months_short.mar"),
      t("date_selector.months_short.apr"),
      t("date_selector.months_short.may"),
      t("date_selector.months_short.jun"),
      t("date_selector.months_short.jul"),
      t("date_selector.months_short.aug"),
      t("date_selector.months_short.sep"),
      t("date_selector.months_short.oct"),
      t("date_selector.months_short.nov"),
      t("date_selector.months_short.dec"),
    ],
    quarters: [
      t("date_selector.quarters.q1"),
      t("date_selector.quarters.q2"),
      t("date_selector.quarters.q3"),
      t("date_selector.quarters.q4"),
    ],
    halfYears: [
      t("date_selector.half_years.h1"),
      t("date_selector.half_years.h2"),
    ],
    weekdays: [
      t("date_selector.weekdays.sunday"),
      t("date_selector.weekdays.monday"),
      t("date_selector.weekdays.tuesday"),
      t("date_selector.weekdays.wednesday"),
      t("date_selector.weekdays.thursday"),
      t("date_selector.weekdays.friday"),
      t("date_selector.weekdays.saturday"),
    ],
    weekdaysShort: [
      t("date_selector.weekdays_short.su"),
      t("date_selector.weekdays_short.mo"),
      t("date_selector.weekdays_short.tu"),
      t("date_selector.weekdays_short.we"),
      t("date_selector.weekdays_short.th"),
      t("date_selector.weekdays_short.fr"),
      t("date_selector.weekdays_short.sa"),
    ],
    placeholder: t("date_selector.placeholder"),
    rangePlaceholder: t("date_selector.range_placeholder"),
  };
};
